import { faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';
import type { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const UploadIcon = (props: Partial<FontAwesomeIconProps>) => (
    <FontAwesomeIcon icon={faCloudUploadAlt} size="2x" {...props} />
);

export default UploadIcon;
